module.exports = __webpack_public_path__ + "static/media/aim.4f7c1c1d.png";